<div class="card border-0">
  <div class="card-body">
    @switch (template) {
      @case ('lines') {
        <p-skeleton width="40%" styleClass="mb-2" />
        <p-skeleton width="30%" styleClass="mb-2" />
        <p-skeleton height=".5rem" styleClass="mb-2" />

        <p-skeleton height="50px" styleClass="mb-2" />
        <p-skeleton height="50px" styleClass="mb-2" />
        <p-skeleton height="50px" />
      }

      @case ('squares') {
        <div class="row">
          <div class="col-12 col-md-6 col-xl-3 mb-4 mb-xl-0">
            <p-skeleton width="100%" height="150px" />
          </div>
          <div class="col-12 col-md-6 col-xl-3 mb-4 mb-xl-0">
            <p-skeleton width="100%" height="150px" />
          </div>
          <div class="col-12 col-md-6 col-xl-3 mb-4 mb-md-0 mb-xl-0">
            <p-skeleton width="100%" height="150px" />
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <p-skeleton width="100%" height="150px" />
          </div>
        </div>
      }

      @case ('image') {
        <div class="row">
          <div class="col-12">
            <p-skeleton width="100%" height="200px" />
          </div>
        </div>
      }
    }
  </div>
</div>
